(function () {
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('pf-js');

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formatNumber(value, decimals) {
    var fixed = Number(value).toFixed(decimals);
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  function finishCount(item) {
    if (item.dataset.pfCounted === 'true') return;
    item.dataset.pfCounted = 'true';
    var target = parseFloat(item.getAttribute('data-pf-count') || '0');
    var decimals = parseInt(item.getAttribute('data-pf-decimals') || '0', 10);
    var prefix = item.getAttribute('data-pf-prefix') || '';
    var suffix = item.getAttribute('data-pf-suffix') || '';
    item.textContent = prefix + formatNumber(target, decimals) + suffix;
  }

  function animateCount(item) {
    if (item.dataset.pfCounted === 'true') return;
    if (reducedMotion || !window.requestAnimationFrame) {
      finishCount(item);
      return;
    }
    item.dataset.pfCounted = 'true';
    var target = parseFloat(item.getAttribute('data-pf-count') || '0');
    var decimals = parseInt(item.getAttribute('data-pf-decimals') || '0', 10);
    var prefix = item.getAttribute('data-pf-prefix') || '';
    var suffix = item.getAttribute('data-pf-suffix') || '';
    var duration = 850;
    var start = null;
    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      item.textContent = prefix + formatNumber(target * eased, decimals) + suffix;
      if (progress < 1) window.requestAnimationFrame(step);
      else item.textContent = prefix + formatNumber(target, decimals) + suffix;
    }
    window.requestAnimationFrame(step);
  }

  function initCounterAnimations() {
    var countItems = Array.prototype.slice.call(document.querySelectorAll('[data-pf-count]'));
    if (!countItems.length) return;
    if (!('IntersectionObserver' in window)) {
      countItems.forEach(finishCount);
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCount(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.35 });
    countItems.forEach(function (item) { observer.observe(item); });
  }


  function formatMoney(cents) {
    var amount = Math.max(0, Number(cents || 0)) / 100;
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: amount % 1 === 0 ? 0 : 2 }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function initAtcQuantityTotals(form) {
    var priceTarget = form.querySelector('[data-pf-atc-price]');
    var quantityInput = form.querySelector('[data-pf-quantity-input], input[name="quantity"]');
    var variantSelect = form.querySelector('select[name="id"]');
    var button = form.querySelector('button[name="add"]');
    if (!priceTarget || !quantityInput || !button) return;

    function unitPriceCents() {
      var checkedPlan = form.querySelector('[data-pf-po]:checked');
      if (checkedPlan && checkedPlan.getAttribute('data-pf-po-price-cents')) {
        return parseInt(checkedPlan.getAttribute('data-pf-po-price-cents'), 10) || 0;
      }
      if (variantSelect && variantSelect.selectedOptions && variantSelect.selectedOptions.length) {
        return parseInt(variantSelect.selectedOptions[0].getAttribute('data-pf-variant-price-cents'), 10) || parseInt(priceTarget.getAttribute('data-pf-unit-price-cents'), 10) || 0;
      }
      return parseInt(priceTarget.getAttribute('data-pf-unit-price-cents'), 10) || 0;
    }

    function quantityValue() {
      var parsed = parseInt(quantityInput.value, 10);
      if (!Number.isFinite(parsed) || parsed < 1) return 1;
      return parsed;
    }

    function updateTotal() {
      var quantity = quantityValue();
      var total = unitPriceCents() * quantity;
      var label = formatMoney(total);
      priceTarget.textContent = label;
      button.setAttribute('aria-label', 'Add ' + quantity + ' to cart, ' + label);
    }

    quantityInput.addEventListener('input', updateTotal);
    quantityInput.addEventListener('change', updateTotal);
    if (variantSelect) variantSelect.addEventListener('change', updateTotal);
    Array.prototype.slice.call(form.querySelectorAll('[data-pf-po]')).forEach(function (option) {
      option.addEventListener('change', updateTotal);
    });
    updateTotal();
  }

  function initProductMedia(mediaRoot) {
    var track = mediaRoot.querySelector('[data-pf-media-track]');
    var slides = Array.prototype.slice.call(mediaRoot.querySelectorAll('[data-pf-media-slide]'));
    var thumbs = Array.prototype.slice.call(mediaRoot.querySelectorAll('[data-pf-media-thumb]'));
    var prev = mediaRoot.querySelector('[data-pf-media-prev]');
    var next = mediaRoot.querySelector('[data-pf-media-next]');
    var productLayout = mediaRoot.closest ? mediaRoot.closest('.pf-product-layout') : null;
    var variantSelect = productLayout ? productLayout.querySelector('select[name="id"]') : null;
    if (!track || !slides.length) return;

    var active = 0;
    function normalizeImageUrl(value) {
      return String(value || '').replace(/^https?:/, '').split('?')[0];
    }

    function setActive(index) {
      active = Math.max(0, Math.min(index, slides.length - 1));
      track.style.transform = 'translate3d(' + (-active * 100) + '%,0,0)';
      thumbs.forEach(function (thumb, thumbIndex) {
        var isActive = thumbIndex === active;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
      if (prev) prev.disabled = active === 0;
      if (next) next.disabled = active === slides.length - 1;
    }

    function setActiveForSelectedVariant() {
      if (!variantSelect || !variantSelect.selectedOptions || !variantSelect.selectedOptions.length) return;
      var option = variantSelect.selectedOptions[0];
      var mediaId = option.getAttribute('data-pf-variant-media-id');
      var imageUrl = normalizeImageUrl(option.getAttribute('data-pf-variant-image'));
      if (!mediaId && !imageUrl) return;
      var targetIndex = slides.findIndex(function (slide) {
        if (mediaId && slide.getAttribute('data-pf-media-id') === mediaId) return true;
        if (!imageUrl) return false;
        var slideImage = normalizeImageUrl(slide.getAttribute('data-pf-media-image'));
        var renderedImage = normalizeImageUrl(slide.querySelector('img') && (slide.querySelector('img').currentSrc || slide.querySelector('img').src));
        return slideImage === imageUrl || renderedImage === imageUrl;
      });
      if (targetIndex >= 0) setActive(targetIndex);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setActive(parseInt(thumb.getAttribute('data-pf-media-thumb') || '0', 10));
      });
    });
    if (prev) prev.addEventListener('click', function () { setActive(active - 1); });
    if (next) next.addEventListener('click', function () { setActive(active + 1); });
    if (variantSelect) variantSelect.addEventListener('change', setActiveForSelectedVariant);

    var startX = null;
    mediaRoot.addEventListener('touchstart', function (event) {
      if (!event.touches || !event.touches.length) return;
      startX = event.touches[0].clientX;
    }, { passive: true });
    mediaRoot.addEventListener('touchend', function (event) {
      if (startX === null || !event.changedTouches || !event.changedTouches.length) return;
      var diff = event.changedTouches[0].clientX - startX;
      if (Math.abs(diff) > 42) setActive(diff < 0 ? active + 1 : active - 1);
      startX = null;
    }, { passive: true });

    mediaRoot.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        setActive(active + 1);
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        setActive(active - 1);
      }
    });

    setActive(0);
    setActiveForSelectedVariant();
  }

  function initIntentScroll() {
    try {
      var params = new URLSearchParams(window.location.search);
      var target = params.get('pf');
      if (!target) return;
      var id = target === 'mission' ? 'pf-mission' : target === 'science' || target === 'proof' ? 'pf-science' : '';
      if (!id) return;
      var el = document.getElementById(id);
      if (!el) return;
      window.setTimeout(function () {
        el.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
        if (window.history && window.history.replaceState) window.history.replaceState(null, document.title, window.location.pathname || '/');
      }, 100);
    } catch (error) {}
  }

  function improveReviewAccessibility() {
    var labels = {
      'complete-multivitamin': 'Read Complete Multivitamin reviews',
      'micronized-creatine-monohydrate-supplement': 'Read Creatine Monohydrate reviews',
      'the-trinity-stack': 'Read The Trinity Stack reviews',
      'vitamin-d3-2000-iu': 'Read Vitamin D3 reviews'
    };
    var links = document.querySelectorAll('.jdgm-carousel-item__product');
    Array.prototype.forEach.call(links, function (link) {
      if ((link.textContent || '').trim() || link.getAttribute('aria-label')) return;
      var href = link.getAttribute('href') || '';
      var label = 'Read PeakFusion product reviews';
      Object.keys(labels).some(function (handle) {
        if (href.indexOf('/products/' + handle) !== -1) {
          label = labels[handle];
          return true;
        }
        return false;
      });
      link.setAttribute('aria-label', label);
    });
  }

  function watchReviewAccessibility() {
    improveReviewAccessibility();
    if (!('MutationObserver' in window)) return;
    var roots = document.querySelectorAll('.pf-home-judgeme-widget, .pf-product-review-widget');
    if (!roots.length) return;
    var observer = new MutationObserver(improveReviewAccessibility);
    Array.prototype.forEach.call(roots, function (root) {
      observer.observe(root, { childList: true, subtree: true });
    });
    window.setTimeout(function () { observer.disconnect(); }, 8000);
  }

  Array.prototype.slice.call(document.querySelectorAll('.pf-product-form')).forEach(initAtcQuantityTotals);
  // Keep the gallery tight: show at most two videos per product, in the order set in Shopify.
  function pruneExtraVideos(mediaRoot) {
    var slides = Array.prototype.slice.call(mediaRoot.querySelectorAll('[data-pf-media-video]'));
    if (slides.length <= 2) return;
    slides.slice(2).forEach(function (slide) {
      var id = slide.getAttribute('data-pf-media-id');
      Array.prototype.slice.call(mediaRoot.querySelectorAll('[data-pf-media-thumb]')).forEach(function (thumb) {
        if (id && thumb.getAttribute('data-pf-media-id') === id) thumb.parentNode.removeChild(thumb);
      });
      slide.parentNode.removeChild(slide);
    });
    Array.prototype.slice.call(mediaRoot.querySelectorAll('[data-pf-media-thumb]')).forEach(function (thumb, i) {
      thumb.setAttribute('data-pf-media-thumb', String(i));
    });
  }

  // Videos fill the frame by default (no black bars). A small icon button switches to the full, uncropped frame and back.
  // The browser's own fullscreen button is removed so the gallery has one clear control.
  function addVideoZoom(mediaRoot) {
    if (!document.getElementById('pf-video-zoom-css')) {
      var style = document.createElement('style');
      style.id = 'pf-video-zoom-css';
      style.textContent = '.pf-product-media__slide--video{position:relative}' +
        '.pf-product-media__slide--video .pf-label-video{object-fit:cover}' +
        '.pf-product-media__slide--video.is-fit .pf-label-video{object-fit:contain}' +
        '.pf-label-video::-webkit-media-controls-fullscreen-button{display:none!important}' +
        '.pf-video-zoom{position:absolute;top:10px;right:10px;z-index:3;width:36px;height:36px;padding:0;display:flex;align-items:center;justify-content:center;border:1px solid rgba(255,255,255,.7);border-radius:50%;background:rgba(0,0,0,.55);color:#fff;cursor:pointer}' +
        '.pf-video-zoom svg{width:18px;height:18px;display:block}' +
        '.pf-video-zoom:focus-visible{outline:2px solid #fff;outline-offset:2px}';
      document.head.appendChild(style);
    }
    var icon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/></svg>';
    Array.prototype.slice.call(mediaRoot.querySelectorAll('[data-pf-media-video]')).forEach(function (slide) {
      var video = slide.querySelector('video');
      if (!video || slide.querySelector('.pf-video-zoom')) return;
      video.setAttribute('controlsList', 'nofullscreen');
      video.setAttribute('disablePictureInPicture', '');
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'pf-video-zoom';
      button.setAttribute('aria-pressed', 'false');
      button.setAttribute('aria-label', 'Show the full video frame');
      button.innerHTML = icon;
      button.addEventListener('click', function (event) {
        event.stopPropagation();
        var fit = slide.classList.toggle('is-fit');
        button.setAttribute('aria-pressed', fit ? 'true' : 'false');
        button.setAttribute('aria-label', fit ? 'Fill the frame' : 'Show the full video frame');
      });
      slide.appendChild(button);
    });
  }

  Array.prototype.slice.call(document.querySelectorAll('[data-pf-product-media]')).forEach(pruneExtraVideos);
  Array.prototype.slice.call(document.querySelectorAll('[data-pf-product-media]')).forEach(addVideoZoom);
  Array.prototype.slice.call(document.querySelectorAll('[data-pf-product-media]')).forEach(initProductMedia);
  initCounterAnimations();
  initIntentScroll();
  watchReviewAccessibility();

  // Whole-dollar prices read cleaner without ".00" ($34, not $34.00). Cents prices such as $28.90 are untouched.
  (function () {
    var re = /\$(\d[\d,]*)\.00(?!\d)/g;
    function clean(root) {
      if (!document.createTreeWalker || !root) return;
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
      var node;
      var hits = [];
      while ((node = walker.nextNode())) {
        var p = node.parentNode;
        if (!p || /^(SCRIPT|STYLE|TEXTAREA|NOSCRIPT)$/.test(p.nodeName)) continue;
        if (node.nodeValue.indexOf('.00') !== -1) hits.push(node);
      }
      hits.forEach(function (n) { n.nodeValue = n.nodeValue.replace(re, '$$$1'); });
    }
    function run() { clean(document.body); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    if (window.MutationObserver) {
      var timer = null;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(run, 60);
      }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
    }
  })();
})();
